'use client'

import { LocationSVG } from '@/components/svg/location/location'
import { SearchIconNew } from '@/components/svg/search-icon-new/search-icon-new'
import { XIcon } from '@/components/svg/x-icon/x-icon'
import { useQueryParams } from '@/hooks/use-query-params'
import { findSelectedLocation } from '@/utils/regions-and-locations'
import Link from 'next/link'
import s from './location-select.module.scss'

type RegionWithLocations = {
  id: number
  name: string
  locations: {
    id: number
    name: string
  }[]
}

type Props = {
  regions: RegionWithLocations[]
  defaultRegion?: number
}

export const LocationSelectButtonClient = (props: Props) => {
  const { getLinkWith, get } = useQueryParams()
  const selectedLocation = get('location') || ''
  const selectedRegion = get('region') || ''
  const defaultRegion =
    !selectedLocation && !selectedRegion && props.defaultRegion
      ? props.defaultRegion
      : undefined

  const foundLocation = findSelectedLocation({
    regions: props.regions,
    location: selectedLocation,
    region: selectedRegion || String(defaultRegion),
  })

  const hasSelectedLocation = !!foundLocation
  const removeSelectedLocationLink = getLinkWith({
    location: null,
    region: null,
    modal: null,
    page: null,
  })
  const openModalLink = getLinkWith({ modal: 'location-select' })

  return (
    <div className={s.button}>
      {hasSelectedLocation ? (
        <div className={s.selectedLocationContainer}>
          <div className={s.searchByLocationText}>Search by location</div>
          <div className={s.selectedLocationTextContainer}>
            <Link
              className={s.locationSvgWithText}
              href={openModalLink}
              scroll={false}
            >
              <LocationSVG /> {foundLocation?.name}
            </Link>
            <Link
              className={s.xIconButton}
              href={removeSelectedLocationLink}
              scroll={false}
            >
              <XIcon className={s.xIcon} />
            </Link>
          </div>
        </div>
      ) : (
        <Link
          className={s.searchByLocationButton}
          href={openModalLink}
          scroll={false}
        >
          <div className={s.locationSvgWithText}>
            <LocationSVG /> Search by location
          </div>
          <div className={s.searchIconButton}>
            <SearchIconNew />
          </div>
        </Link>
      )}
    </div>
  )
}
